module.exports = __webpack_public_path__ + "img/39_39.38e4a8ea.png";